import { c as _c } from "react/compiler-runtime";
import { chakra, Box, Button, Separator, VStack, Alert, Spinner, Center } from '@chakra-ui/react';
import { useColorMode } from '@src/components/chakra-ui/color-mode.tsx';
import { GenericFormProps } from '@src/components/sco/Form/formHelpers';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { startupsUrl } from '@src/lib/startups-url';
import { tokens } from '@src/theme/tokens';
import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe, PaymentMethod, StripePaymentElement } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';
type StripePaymentMethodFormFields = {};
type StripePaymentMethodFormProps = GenericFormProps<StripePaymentMethodFormFields> & {
  onPaymentMethodReady?: (paymentMethod: PaymentMethod) => void;
  amountsDueInCents?: {
    signup?: number;
    recurring?: number;
  };
  onStripeReady?: (stripeInstance) => void;
  trialDays?: any;
};
export const StripePaymentMethodForm = props => {
  const $ = _c(44);
  const elements = useElements();
  const stripe = useStripe();
  const {
    currentUser
  } = useCurrentUser();
  const [errorMessage, setErrorMessage] = useState(null);
  const [paymentElement, setPaymentElement] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [processing, setProcessing] = useState(false);
  let t0;
  if ($[0] !== paymentMethod || $[1] !== props) {
    t0 = () => {
      if (paymentMethod?.id) {
        props.onPaymentMethodReady(paymentMethod);
      }
    };
    $[0] = paymentMethod;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = paymentMethod?.id;
  let t2;
  if ($[3] !== t1) {
    t2 = [t1];
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t0, t2);
  let t3;
  if ($[5] !== props || $[6] !== stripe) {
    t3 = () => {
      props.onStripeReady(stripe);
    };
    $[5] = props;
    $[6] = stripe;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== stripe) {
    t4 = [stripe];
    $[8] = stripe;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== elements || $[11] !== paymentElement || $[12] !== stripe) {
    t5 = async event => {
      event.preventDefault();
      setErrorMessage(null);
      setProcessing(true);
      if (!stripe || !elements) {
        alert("Stripe or Elements not ready.");
        return;
      }
      await elements.submit();
      const paymentMethodResult = await stripe.createPaymentMethod({
        element: paymentElement
      });
      if (paymentMethodResult.error) {
        setErrorMessage(paymentMethodResult.error.message);
        setProcessing(false);
        return;
      }
      if (paymentMethodResult.paymentMethod) {
        setPaymentMethod(paymentMethodResult.paymentMethod);
        setProcessing(false);
        return;
      }
      setProcessing(false);
    };
    $[10] = elements;
    $[11] = paymentElement;
    $[12] = stripe;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const handleSubmit = t5;
  if (!currentUser) {
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Center padding="3em"><Spinner /></Center>;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    return t6;
  }
  let t6;
  if ($[15] !== errorMessage) {
    t6 = errorMessage && <Alert.Root borderRadius="md" status="error"><Alert.Indicator /><Box marginLeft="1em">{errorMessage}</Box></Alert.Root>;
    $[15] = errorMessage;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["card"];
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== currentUser.email || $[19] !== currentUser.fullName) {
    t8 = {
      billingDetails: {
        name: currentUser.fullName,
        email: currentUser.email
      }
    };
    $[18] = currentUser.email;
    $[19] = currentUser.fullName;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = props.amountsDueInCents?.recurring || props.amountsDueInCents?.signup || 0;
  let t10;
  if ($[21] !== t9) {
    t10 = {
      label: "Recurring Membership",
      amount: t9
    };
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = startupsUrl("/account/billing");
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10) {
    t12 = {
      recurringPaymentRequest: {
        paymentDescription: "Recurring Membership",
        regularBilling: t10,
        managementURL: t11
      }
    };
    $[24] = t10;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t8) {
    t13 = {
      layout: "auto",
      paymentMethodOrder: t7,
      defaultValues: t8,
      applePay: t12
    };
    $[26] = t12;
    $[27] = t8;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = element => setPaymentElement(element);
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t13) {
    t15 = <PaymentElement options={t13} onReady={t14} />;
    $[30] = t13;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Separator marginY="1em" />;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const t17 = !stripe;
  const t18 = props.trialDays ? `Start ${props.trialDays}-Day Trial` : "Submit";
  let t19;
  if ($[33] !== processing || $[34] !== t17 || $[35] !== t18) {
    t19 = <Button disabled={t17} loading={processing} type="submit" variant="cta" width="full">{t18}</Button>;
    $[33] = processing;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== handleSubmit || $[38] !== t15 || $[39] !== t19) {
    t20 = <chakra.form onSubmit={handleSubmit}>{t15}{t16}{t19}</chakra.form>;
    $[37] = handleSubmit;
    $[38] = t15;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t20 || $[42] !== t6) {
    t21 = <VStack align="stretch" gap="1.5em" width="100%">{t6}{t20}</VStack>;
    $[41] = t20;
    $[42] = t6;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  return t21;
};
export const StripePaymentMethod = props => {
  const $ = _c(17);
  const {
    currentUser
  } = useCurrentUser();
  const {
    colorMode
  } = useColorMode();
  const isDarkMode = colorMode === "dark";
  const colors = tokens.tokens.colors;
  if (!currentUser) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Center padding="3em"><Spinner /></Center>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHED_KEY);
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = isDarkMode ? colors.purple["900"].value : colors.orange.card;
  const t2 = isDarkMode ? colors.red["500"].value : colors.red["500"].value;
  const t3 = isDarkMode ? colors.purple["300"].value : colors.orange["600"].value;
  const t4 = isDarkMode ? colors.green["500"].value : colors.green["500"].value;
  const t5 = isDarkMode ? colors.gray["100"].value : colors.gray["900"].value;
  const t6 = isDarkMode ? colors.gray["200"].value : colors.gray["900"].value;
  let t7;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = {
      theme: "stripe",
      variables: {
        borderRadius: "6px",
        colorBackground: t1,
        colorDanger: t2,
        colorPrimary: t3,
        colorSuccess: t4,
        colorText: t5,
        colorTextPlaceholder: t6,
        fontFamily: "Lato, system-ui, sans-serif",
        spacingUnit: "4px",
        gridRowSpacing: "16px",
        fontSizeBase: "16px"
      }
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["card"];
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7) {
    t9 = {
      appearance: t7,
      paymentMethodTypes: t8,
      currency: "usd",
      mode: "setup",
      paymentMethodCreation: "manual"
    };
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== props) {
    t10 = <StripePaymentMethodForm {...props} />;
    $[12] = props;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <><Elements stripe={t0} options={t9}>{t10}</Elements></>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};